import { createAction, createSlice } from '@reduxjs/toolkit';

import { resetStateAction } from '!core/redux';

const initialState = {
  daily: { data: [] },
  history: { data: [] },
  currentTab: 0,
};

const logoutSuccessAction = createAction('logoutSlice/logoutSuccess');

const clearState = () => ({ ...initialState });

export const publicOfferSlice = createSlice({
  name: 'publicOfferSlice',
  initialState,
  reducers: {
    publicOfferDailyRequest: (state) => {
      state.daily.isLoading = true;
    },
    publicOfferDailySucess: (state, action) => {
      state.daily.data = action.payload.map((el) => ({
        ...el,
        expanded: false,
      }));
      state.daily.isLoading = false;
    },
    publicOfferDailyFailure: (state) => {
      state.daily.isLoading = false;
    },
    publicOfferHstRequest: (state) => {
      state.history.isLoading = true;
    },
    publicOfferHstSucess: (state, action) => {
      state.history.data = action.payload.map((el) => ({
        ...el,
        expanded: false,
      }));
      state.history.isLoading = false;
    },
    publicOfferHstFailure: (state) => {
      state.history.isLoading = false;
    },
    setCurrentTab: (state, action) => {
      state.currentTab = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logoutSuccessAction, clearState)
      .addCase(resetStateAction, clearState);
  },
});
